import { IPublicClientApplication } from '@azure/msal-browser'
import { protectedResources } from '../authConfig'
import { Notification } from '../models/Notification'
import { authorizedGet, authorizedPatch } from '../utils/authUtils'

const baseUrl = process.env.REACT_APP_BASE_API_URL

export const fetchNotifications = async (
  instance: IPublicClientApplication,
  organizationId: number,
): Promise<Notification[]> => {
  return await authorizedGet(
    instance,
    `${baseUrl}/Notifications?organizationId=${organizationId}`,
    protectedResources.scopes.read,
  )
}

export const fetchUnreadCount = async (
  instance: IPublicClientApplication,
  organizationId: number,
): Promise<number> => {
  return await authorizedGet(
    instance,
    `${baseUrl}/Notifications/unread-count?organizationId=${organizationId}`,
    protectedResources.scopes.read,
  )
}

export const markNotificationAsRead = async (
  id: number,
  instance: IPublicClientApplication,
): Promise<void> => {
  return await authorizedPatch(
    instance,
    `${baseUrl}/Notifications/${id}/mark-read`,
    {},
    protectedResources.scopes.read,
  )
}

export const markAllNotificationsAsRead = async (
  instance: IPublicClientApplication,
  organizationId: number,
): Promise<void> => {
  return await authorizedPatch(
    instance,
    `${baseUrl}/Notifications/mark-all-read?organizationId=${organizationId}`,
    {},
    protectedResources.scopes.read,
  )
}
